module.exports = __webpack_public_path__ + "img/7.fcd9dfcd.jpg";